import { Unicode } from './unicodes';

export const EmptyValues = {
  EnDash: Unicode.EnDash,
  NotApplicable: 'N/A',
};
